import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { Tag } from 'primereact/tag'
import { AHCREvent } from '../types/ahcr-event.types'
import { getColorInfo, getGenderInfo, getHatInfo } from '../utils/ahcr-event-formatters'

interface AHCREventListItemProps {
  event: AHCREvent
  onViewDetails: (event: AHCREvent) => void
  onImageClick: (url: string) => void
}

const AHCREventListItem = ({ event, onViewDetails, onImageClick }: AHCREventListItemProps) => {
  const date = new Date(event.createdDate)
  const genderInfo = getGenderInfo(event.gender)
  const hatInfo = getHatInfo(event.hat)

  return (
    <div className='col-12'>
      <Card className='event-list-card'>
        <div className='grid'>
          <div className='col-12 md:col-3'>
            <div
              className='event-list-image'
              onClick={() => event.detectionImageUrl && onImageClick(event.detectionImageUrl)}
            >
              {event.detectionImageUrl ? (
                <div className='event-image-wrapper'>
                  <img src={event.detectionImageUrl} alt='Pessoa' className='event-main-image' />
                  <div className='event-image-overlay'>
                    <i className='pi pi-search-plus' />
                  </div>
                </div>
              ) : (
                <div className='event-no-image'>
                  <i className='pi pi-image' />
                </div>
              )}
            </div>
          </div>

          <div className='col-12 md:col-6'>
            <div className='flex flex-column gap-3'>
              <div className='flex align-items-center gap-3'>
                {event.gender ? (
                  <Tag value={genderInfo.label} severity={genderInfo.severity} icon={`pi ${genderInfo.icon}`} />
                ) : (
                  <Tag value='Sem classificação' severity='secondary' icon='pi pi-question-circle' />
                )}
              </div>

              <div className='grid'>
                <div className='col-6'>
                  <div className='event-list-info'>
                    <i className='pi pi-calendar text-primary' />
                    <div>
                      <small className='text-muted block'>Data & Hora</small>
                      <span className='font-semibold'>{date.toLocaleDateString('pt-BR')}</span>
                      <br />
                      <span className='text-sm'>{date.toLocaleTimeString('pt-BR')}</span>
                    </div>
                  </div>
                </div>

                <div className='col-6'>
                  <div className='event-list-info'>
                    <i className='pi pi-video text-primary' />
                    <div>
                      <small className='text-muted block'>Câmera</small>
                      <span className='font-semibold'>{event.cameraName}</span>
                    </div>
                  </div>
                </div>


                {event.trousersColor && (
                  <div className='col-6'>
                    <div className='event-list-info'>
                      <i className='pi pi-palette text-primary' />
                      <div>
                        <small className='text-muted block'>Cor da Calça</small>
                        <span className={`events-color-badge events-color-${event.trousersColor?.toLowerCase()}`}>
                          {getColorInfo(event.trousersColor)}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className='col-12 md:col-3 flex align-items-center justify-content-center'>
            <div className='flex flex-column gap-2 w-full'>
              <Button
                icon='pi pi-eye'
                label='Ver Detalhes'
                className='p-button-sm w-full'
                onClick={() => onViewDetails(event)}
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default AHCREventListItem
